export default __webpack_public_path__ + "static/media/synchronize.421bdf54.svg";